import React, {useEffect, useState} from "react";
import {ResponseInterface} from "../../../interfaces/ResponseInterface";
import QModal from "../../../common/components/QModal";
import SetupApi from "../../../common/api/functions/Setup";
import BodyEconomicComponent from "./components/BodyEconomicComponent";
import {SetupInterface} from "../../../interfaces/private/SetupInterface";
import {config} from "../../../config";
import {QHelpers} from "../../../common/helpers";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {useHistory, Link} from "react-router-dom";
import {setToast} from "../../../app/rootReducer";
import QButton from "../../../common/components/QButton";
import {maskEconomicToken, redirectToEconomicOAuth} from "../../../common/helpers/economicOAuth";
import BodyCommonSetupComponent from "./components/BodyCommonSetupComponent";
import BodyInvoiceSetupComponent from "./components/BodyInvoiceSetupComponent";
import {
    AccountInterface, CustomerGroupInterface,
    JournalInterface,
    LayoutInterface,
    PaymentTermInterface, ProductGroupInterface, VatZoneInterface
} from "../../../interfaces/economic/CommonInterface";
import BodyPaymentSetupComponent from "./components/BodyPaymentSetupComponent";
import BodyPayoutSetupComponent from "./components/BodyPayoutSetupComponent";
import BodySubscriptionSetupComponent from "./components/BodySubscriptionSetupComponent";
import BodyRefundSetupComponent from "./components/BodyRefundSetupComponent";
import SetupSectionCard from "./components/SetupSectionCard";
import SettingsPageHeader from "../Settings/components/SettingsPageHeader";
import SettingsPanelCard from "../Settings/components/SettingsPanelCard";
import {
    displaySetupValue,
    getEffectiveSyncModules,
    getIncompleteEnabledSections,
    isSetupSectionComplete,
    isSyncModuleEnabled,
    shouldShowCommonSetup,
    usesCustomerBalanceLedger,
} from "./helpers/setupCompleteness";
import {
    SyncModuleKey,
} from "../../public/SetupV2/helpers/onboardingModules";
import {RouteDefine} from "../../../routes/RouteDefine";

export function Economic() {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [setup, setSetup] = useState<SetupInterface>({});
    const [loading, setLoading] = useState(true);
    const [togglingModule, setTogglingModule] = useState<SyncModuleKey | null>(null);
    const [createNewClick, setCreateNewClick] = useState(false);
    const [openModalSetupInvoice, setOpenModalSetupInvoice] = useState(false);
    const [openModalSetupPayment, setOpenModalSetupPayment] = useState(false);
    const [openModalSetupPayout, setOpenModalSetupPayout] = useState(false);
    const [openModalSetupSubscription, setOpenModalSetupSubscription] = useState(false);
    const [openModalSetupRefund, setOpenModalSetupRefund] = useState(false);
    const [openModalSetupCommon, setOpenModalSetupCommon] = useState(false);

    const [layouts, setLayouts] = useState<LayoutInterface[]>([]);
    const [paymentTerms, setPaymentTerms] = useState<PaymentTermInterface[]>([]);
    const [bookedWiths, setBookedWiths] = useState<any>({});
    const [otherRef, setOtherRef] = useState<any>({});
    const [cashbooks, setCashbooks] = useState<JournalInterface[]>([]);
    const [accounts, setAccounts] = useState<AccountInterface[]>([]);
    const [customerGroups, setCustomerGroups] = useState<CustomerGroupInterface[]>([]);
    const [productGroups, setProductGroups] = useState<ProductGroupInterface[]>([]);
    const [vatZones, setVatZones] = useState<VatZoneInterface[]>([]);
    const [allDataSetup, setAllDataSetup] = useState<any>({});

    let objectParams = QHelpers.object.convertParamUrlToObject(window.location.search);
    const deepLinkHandled = React.useRef(false);

    useEffect(() => {
        if (loading) {
            Promise.all([
                load().then(async () => {
                }),
                SetupApi.getAllDataSetup().then(async (response: ResponseInterface | any) => {
                    setAllDataSetup(response?.data?.data);
                    let {
                        layouts,
                        paymentTerms,
                        bookedWiths,
                        otherRef,
                        cashbooks,
                        accounts,
                        customerGroups,
                        productGroups,
                        vatZones
                    } = response?.data?.data;
                    setLayouts(layouts);
                    setPaymentTerms(paymentTerms);
                    setBookedWiths(bookedWiths);
                    setOtherRef(otherRef);
                    setCashbooks(cashbooks);
                    setAccounts(accounts);
                    setCustomerGroups(customerGroups);
                    setProductGroups(productGroups);
                    setVatZones(vatZones || []);
                }),
            ]).then(async () => {
                await setLoading(false);

                if (deepLinkHandled.current) {
                    return;
                }
                const setupKey = objectParams?.setup;
                if (!setupKey) {
                    return;
                }
                deepLinkHandled.current = true;
                switch (String(setupKey)) {
                    case "invoice":
                        setOpenModalSetupInvoice(true);
                        break;
                    case "payment":
                        setOpenModalSetupPayment(true);
                        break;
                    case "payout":
                        setOpenModalSetupPayout(true);
                        break;
                    case "subscription":
                        setOpenModalSetupSubscription(true);
                        break;
                    case "refund":
                        setOpenModalSetupRefund(true);
                        break;
                    case "common":
                        setOpenModalSetupCommon(true);
                        break;
                    default:
                        break;
                }
            });
        }
    }, [loading])

    useEffect(() => {
        if (objectParams?.connected === "1") {
            dispatch(setToast({
                message: t("economic.oauthSuccess"),
                type: config.TOAST_TYPE.SUCCESS,
            }));
            history.replace(window.location.pathname);
        }
    }, [objectParams?.connected, dispatch, history, t]);

    const handleOAuthReconnect = () => {
        redirectToEconomicOAuth();
    };

    const isConnected = Boolean(setup.economic_token);
    const notSet = t("economic.notSet");

    const load = async () => {
        try {
            await SetupApi.detail().then(async (response: ResponseInterface | any) => {
                if (response?.status === config.STATUS_CODE.OK) {
                    setSetup(
                        response?.data?.data || {}
                    )
                }
            })

        } catch (err) {
            console.error(err);
        } finally {
            await setLoading(false);
        }
    }

    const getDisplayFromSelection = (items: any[],
                                     key: string,
                                     value: string | number,
                                     displayKey: string,
                                     additionalKey?: string): string => {
        const item = items.find((i: any) => i[key] == value);
        if (item) {
            const displayValue = item[displayKey];
            const additionalValue = additionalKey ? item[additionalKey] : null;
            return additionalValue ? `${displayValue} - ${additionalValue}` : displayValue;
        }
        return notSet;
    };

    const getVatZoneDisplay = (value: string|number|undefined, fallback: number): string => {
        const vatZoneNumber = Number(value) || fallback;
        const vatZone = vatZones.find((item) => item.vatZoneNumber === vatZoneNumber);

        return vatZone ? `${vatZone.name} (#${vatZoneNumber})` : (value ? `#${vatZoneNumber}` : notSet);
    };

    const isCheckout = setup.stripe_invoice_source === 'checkout';
    const pricesIncludeVatActive = !!setup.stripe_checkout_prices_include_vat;
    const isLedger = usesCustomerBalanceLedger(setup);
    const incompleteSections = getIncompleteEnabledSections(setup);
    const showCommon = shouldShowCommonSetup(setup);

    const sectionLabel = (key: string) => {
        const map: Record<string, string> = {
            invoice: t("economic.sectionInvoice"),
            refund: t("economic.sectionRefund"),
            payment: t("economic.sectionPayment"),
            payout: t("economic.sectionPayout"),
            subscription: t("economic.sectionSubscription"),
            common: t("economic.sectionCommon"),
        };
        return map[key] || key;
    };

    const openSetupSection = (key: string) => {
        switch (key) {
            case "invoice":
                setOpenModalSetupInvoice(true);
                break;
            case "common":
                setOpenModalSetupCommon(true);
                break;
            case "payment":
                setOpenModalSetupPayment(true);
                break;
            case "payout":
                setOpenModalSetupPayout(true);
                break;
            case "subscription":
                setOpenModalSetupSubscription(true);
                break;
            case "refund":
                setOpenModalSetupRefund(true);
                break;
            default:
                break;
        }
    };

    const invoiceSectionComplete = isSetupSectionComplete("invoice", setup);
    const refundSectionComplete = isSetupSectionComplete("refund", setup);
    const commonSectionComplete = isSetupSectionComplete("common", setup);

    const setModuleEnabled = async (module: SyncModuleKey, enabled: boolean) => {
        if (isLedger && module === "invoice" && enabled) {
            dispatch(setToast({
                message: t("economic.accountingModeInvoiceSkippedHelp"),
                type: config.TOAST_TYPE.ERROR,
            }));
            return;
        }

        if (!enabled && !window.confirm(t("economic.moduleDisableConfirm"))) {
            return;
        }

        const effective = getEffectiveSyncModules(setup);
        const next = enabled
            ? Array.from(new Set([...effective, module]))
            : effective.filter((m) => m !== module);

        setTogglingModule(module);
        try {
            const response: ResponseInterface | any = await SetupApi.update({
                ...setup,
                enabled_sync_modules: next,
            });
            if (response?.status === config.STATUS_CODE.OK) {
                setSetup(response?.data?.data || {
                    ...setup,
                    enabled_sync_modules: next,
                });
                dispatch(setToast({
                    message: enabled ? t("economic.moduleEnabled") : t("economic.moduleDisabledSuccess"),
                    type: config.TOAST_TYPE.SUCCESS,
                }));
            } else {
                dispatch(setToast({
                    message: t("economic.moduleToggleError"),
                    type: config.TOAST_TYPE.ERROR,
                }));
            }
        } catch {
            dispatch(setToast({
                message: t("economic.moduleToggleError"),
                type: config.TOAST_TYPE.ERROR,
            }));
        } finally {
            setTogglingModule(null);
        }
    };

    /** Ledger needs Payment + Payout (+ Refund) — enable if merchant had only Invoice/Payment from onboarding. */
    const ensureLedgerModulesEnabled = async (current: SetupInterface): Promise<SetupInterface> => {
        const effective = getEffectiveSyncModules(current);
        const required: SyncModuleKey[] = ["payment", "payout", "refund"];
        const missing = required.filter((m) => !effective.includes(m));
        if (missing.length === 0) {
            return current;
        }
        const next = Array.from(new Set([...effective, ...missing]));
        try {
            const response: ResponseInterface | any = await SetupApi.update({
                ...current,
                enabled_sync_modules: next,
            });
            if (response?.status === config.STATUS_CODE.OK) {
                const updated = response?.data?.data || {...current, enabled_sync_modules: next};
                setSetup(updated);
                return updated;
            }
        } catch {
            // fall through
        }
        const fallback = {...current, enabled_sync_modules: next};
        setSetup(fallback);
        return fallback;
    };

    return (
        <React.Fragment>
            <QModal
                open={createNewClick}
                setOpen={setCreateNewClick}
                headerContent={t("economic.manualUpdateTitle")}
                bodyContent={(
                    <BodyEconomicComponent
                        model={setup}
                        setOpen={setCreateNewClick}
                        setSetup={setSetup}
                        setLoadingFunc={setLoading}
                        onSuccess={load}
                    />
                )}
            />
            <QModal
                open={openModalSetupInvoice}
                setOpen={setOpenModalSetupInvoice}
                headerContent={t("economic.sectionInvoice")}
                bodyContent={(
                    <BodyInvoiceSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupInvoice}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                    />
                )}
            />
            <QModal
                open={openModalSetupPayment}
                setOpen={setOpenModalSetupPayment}
                headerContent={t("economic.sectionPayment")}
                bodyContent={(
                    <BodyPaymentSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupPayment}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                        onSaved={(updatedSetup) => {
                            if (
                                usesCustomerBalanceLedger(updatedSetup)
                                && !isSetupSectionComplete("payout", updatedSetup)
                            ) {
                                dispatch(setToast({
                                    message: t("economic.accountingModeConfigurePayout"),
                                    type: config.TOAST_TYPE.SUCCESS,
                                }));
                                setOpenModalSetupPayout(true);
                            }
                        }}
                    />
                )}
            />
            <QModal
                open={openModalSetupPayout}
                setOpen={setOpenModalSetupPayout}
                headerContent={t("economic.sectionPayout")}
                bodyContent={(
                    <BodyPayoutSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupPayout}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                    />
                )}
            />
            <QModal
                open={openModalSetupSubscription}
                setOpen={setOpenModalSetupSubscription}
                headerContent={t("economic.sectionSubscription")}
                bodyContent={(
                    <BodySubscriptionSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupSubscription}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                    />
                )}
            />
            <QModal
                open={openModalSetupRefund}
                setOpen={setOpenModalSetupRefund}
                headerContent={t("economic.sectionRefund")}
                bodyContent={(
                    <BodyRefundSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupRefund}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                    />
                )}
            />
            <QModal
                open={openModalSetupCommon}
                setOpen={setOpenModalSetupCommon}
                headerContent={t("economic.sectionCommon")}
                bodyContent={(
                    <BodyCommonSetupComponent
                        model={setup}
                        setOpen={setOpenModalSetupCommon}
                        setSetup={setSetup}
                        setup={setup}
                        setLoadingFunc={setLoading}
                        allDataSetup={allDataSetup}
                        onLedgerActivated={async (updatedSetup) => {
                            await ensureLedgerModulesEnabled(updatedSetup);
                            dispatch(setToast({
                                message: t("economic.accountingModeConfigureSalesAccount"),
                                type: config.TOAST_TYPE.SUCCESS,
                            }));
                            setOpenModalSetupPayment(true);
                        }}
                    />
                )}
            />
            <div className="row">
                <SettingsPageHeader
                    title={t("economic.title")}
                    subtitle={t("economic.pageSubtitle")}
                    showBackToDashboard
                    actions={(
                        <>
                            <Link to={RouteDefine.help} className="btn btn-sm btn-light">
                                {t("common.navbar.help")}
                            </Link>
                            <QButton
                                type="primary"
                                onClick={handleOAuthReconnect}
                                content={isConnected ? t("economic.reconnectOAuth") : t("economic.connectOAuth")}
                            />
                            <QButton
                                type="default"
                                onClick={() => setCreateNewClick(true)}
                                content={t("economic.manualUpdate")}
                            />
                        </>
                    )}
                />
                {loading ? (
                    <div className="col-lg-12 placeholder-glow">
                        <div className="business-detail bg-orange-bland-zp bdr-20 pd-25 mb-3">
                            <span className="placeholder col-4 mb-3 d-block"/>
                            <span className="placeholder col-8 d-block"/>
                        </div>
                        {[0, 1, 2].map((i) => (
                            <div key={i} className="business-detail bg-orange-bland-zp bdr-20 pd-25 mb-3" style={{minHeight: 120}}>
                                <span className="placeholder col-5 mb-3 d-block"/>
                                <span className="placeholder col-7 mb-2 d-block"/>
                                <span className="placeholder col-6 d-block"/>
                            </div>
                        ))}
                    </div>
                ) : (
                <div className="col-lg-12">
                    <SettingsPanelCard
                        title={t("economic.token")}
                        badge={{
                            label: isConnected ? t("economic.connected") : t("economic.notConnected"),
                            variant: isConnected ? "success" : "secondary",
                        }}
                        help={!isConnected ? t("economic.notConnectedHelp") : undefined}
                        fields={[
                            {
                                label: t("economic.token"),
                                value: (
                                    <code className="text-muted">
                                        {isConnected
                                            ? maskEconomicToken(setup.economic_token)
                                            : t("economic.notConnected")}
                                    </code>
                                ),
                                fullWidth: true,
                            },
                        ]}
                    />

                    {incompleteSections.length > 0 && (
                        <div className="alert alert-warning mb-3 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2" role="status">
                            <div>
                                <strong>{t("economic.setupHealthTitle")}</strong>
                                <div className="small mt-1">{t("economic.setupHealthHelp")}</div>
                                <div className="mt-2">
                                    {incompleteSections.map((key) => (
                                        <span key={key} className="badge bg-warning text-dark me-1">
                                            {sectionLabel(key)}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <QButton
                                type="primary"
                                className="btn-sm flex-shrink-0"
                                onClick={() => openSetupSection(incompleteSections[0])}
                                content={t("economic.setupHealthFixFirst")}
                            />
                        </div>
                    )}

                    {showCommon ? (
                        <SetupSectionCard
                            title={t("economic.sectionCommon")}
                            complete={commonSectionComplete}
                            onEdit={() => setOpenModalSetupCommon(true)}
                            fields={[
                                {
                                    label: t("economic.customerGroup"),
                                    value: displaySetupValue(
                                        customerGroups.find((l: CustomerGroupInterface) => l.customerGroupNumber == setup.economic_customer_group_number)?.name,
                                        notSet
                                    ),
                                },
                                {
                                    label: t("economic.customerPaymentTerms"),
                                    value: displaySetupValue(
                                        paymentTerms.find((l: PaymentTermInterface) => l.paymentTermsNumber == setup.economic_customer_payment_terms_number)?.name,
                                        notSet
                                    ),
                                },
                                {
                                    label: t("economic.productGroup"),
                                    value: displaySetupValue(
                                        productGroups.find((l: ProductGroupInterface) => l.productGroupNumber == setup.economic_product_group_number)?.name,
                                        notSet
                                    ),
                                },
                                {
                                    label: t("economic.accountingMode"),
                                    value: (setup.accounting_mode || "invoice_matching") === "customer_balance_ledger"
                                        ? t("economic.accountingModeCustomerLedger")
                                        : t("economic.accountingModeInvoiceMatching"),
                                    highlight: (setup.accounting_mode || "invoice_matching") === "customer_balance_ledger",
                                    fullWidth: true,
                                },
                                {
                                    label: t("economic.excludedEmailDomains"),
                                    value: Array.isArray(setup.excluded_email_domains) && setup.excluded_email_domains.length
                                        ? setup.excluded_email_domains.join(", ")
                                        : t("economic.excludedEmailDomainsNone"),
                                    fullWidth: true,
                                },
                            ]}
                        >
                            <p className="text-muted small mb-3">{t("economic.sectionCommonHelp")}</p>
                            {(setup.accounting_mode || "invoice_matching") === "customer_balance_ledger" ? (
                                <div className="alert alert-warning py-2 mb-0" role="status">
                                    {t("economic.accountingModeCustomerLedgerHelp")}
                                </div>
                            ) : null}
                        </SetupSectionCard>
                    ) : null}

                    <SetupSectionCard
                        title={t("economic.sectionInvoice")}
                                enabled={isSyncModuleEnabled(setup, "invoice")}
                                toggling={togglingModule === "invoice"}
                                onToggleEnabled={(enabled) => setModuleEnabled("invoice", enabled)}
                                accountingBlocked={isLedger}
                                accountingBlockedBadge={t("economic.accountingModeSkippedBadge")}
                                accountingBlockedHelp={t("economic.accountingModeInvoiceSkippedHelp")}
                                complete={invoiceSectionComplete}
                                onEdit={() => setOpenModalSetupInvoice(true)}
                                fields={[
                                    {
                                        label: t("economic.source"),
                                        value: isCheckout ? "Stripe Checkout" : "Stripe Invoice",
                                    },
                                    ...(pricesIncludeVatActive ? [{
                                        label: t("economic.checkoutPricesIncludeVat"),
                                        value: `${t("economic.yes")} (${setup.stripe_checkout_included_vat_rate ?? 25}%)`,
                                        highlight: true,
                                    }] : []),
                                    {
                                        label: t("economic.layout"),
                                        value: displaySetupValue(
                                            layouts.find((l: LayoutInterface) => l.layoutNumber == setup.economic_invoice_layout_number)?.name,
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.paymentTerms"),
                                        value: displaySetupValue(
                                            paymentTerms.find((l: PaymentTermInterface) => l.paymentTermsNumber == setup.economic_invoice_payment_terms_number)?.name,
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.bookedWith"),
                                        value: displaySetupValue(bookedWiths[setup.economic_invoice_booked_with], notSet),
                                    },
                                    ...(String(setup.economic_invoice_booked_with) === '2' ? [{
                                        label: t("economic.sendOutInvoice"),
                                        value: setup.economic_invoice_send_out ? t("economic.yes") : t("economic.no"),
                                    }] : []),
                                    {
                                        label: t("economic.otherRef"),
                                        value: displaySetupValue(otherRef[setup.economic_invoice_other_ref], notSet),
                                    },
                                    {
                                        label: t("economic.productDiscount"),
                                        value: displaySetupValue(setup.economic_invoice_product_discount_number, notSet),
                                    },
                                    {
                                        label: t("economic.vatZoneDomestic"),
                                        value: getVatZoneDisplay(setup.economic_invoice_vat_zone_domestic_number, 1),
                                    },
                                    {
                                        label: t("economic.vatZoneEu"),
                                        value: getVatZoneDisplay(setup.economic_invoice_vat_zone_eu_number, 2),
                                    },
                                    {
                                        label: t("economic.vatZoneAbroad"),
                                        value: getVatZoneDisplay(setup.economic_invoice_vat_zone_abroad_number, 3),
                                    },
                                    {
                                        label: t("economic.vatZoneDomesticWithoutVat"),
                                        value: getVatZoneDisplay(
                                            setup.economic_invoice_vat_zone_domestic_without_vat_number,
                                            Number(setup.economic_invoice_vat_zone_domestic_number) || 1
                                        ),
                                    },
                                ]}
                            >
                                {pricesIncludeVatActive && (
                                    <div className="alert alert-warning py-2 mb-3" role="status">
                                        {t("economic.checkoutVatHint")}
                                    </div>
                                )}
                            </SetupSectionCard>

                            <SetupSectionCard
                                title={t("economic.sectionRefund")}
                                enabled={isSyncModuleEnabled(setup, "refund")}
                                toggling={togglingModule === "refund"}
                                onToggleEnabled={(enabled) => setModuleEnabled("refund", enabled)}
                                complete={refundSectionComplete}
                                onEdit={() => setOpenModalSetupRefund(true)}
                                fields={isLedger ? [
                                    {
                                        label: t("economic.sectionRefundHelpLedger"),
                                        value: t("economic.ready"),
                                        fullWidth: true,
                                        highlight: true,
                                    },
                                ] : [
                                    {
                                        label: t("economic.usesInvoiceSettings"),
                                        value: isSetupSectionComplete("invoice", setup)
                                            ? t("economic.ready")
                                            : t("economic.configureInvoiceFirst"),
                                        fullWidth: true,
                                    },
                                    {
                                        label: t("economic.refundBookedWith"),
                                        value: displaySetupValue(
                                            bookedWiths[setup.economic_refund_booked_with ?? "1"],
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.sectionRefundHelp"),
                                        value: "",
                                        fullWidth: true,
                                    },
                                ]}
                            />

                            <SetupSectionCard
                                title={t("economic.sectionPayment")}
                                enabled={isSyncModuleEnabled(setup, "payment")}
                                toggling={togglingModule === "payment"}
                                onToggleEnabled={(enabled) => setModuleEnabled("payment", enabled)}
                                complete={isSetupSectionComplete("payment", setup)}
                                onEdit={() => setOpenModalSetupPayment(true)}
                                fields={[
                                    {
                                        label: t("economic.cashbook"),
                                        value: displaySetupValue(
                                            cashbooks.find((l: JournalInterface) => l.journalNumber == setup.economic_payment_cashbook_number)?.name,
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.bankAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payment_bank_account_number,'accountNumber','name'),
                                    },
                                    {
                                        label: t("economic.feeAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payment_fee_account_number,'accountNumber','name'),
                                    },
                                    {
                                        label: t("economic.differenceAccountCurrency"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payment_difference_currency_account_number,'accountNumber','name'),
                                    },
                                    ...((setup.accounting_mode || "invoice_matching") === "customer_balance_ledger" ? [{
                                        label: t("economic.salesAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payment_sales_account_number,'accountNumber','name'),
                                        highlight: true,
                                    }] : [
                                        {
                                            label: t("economic.matchingInvoice"),
                                            value: setup.economic_payment_matching_invoice ? t("economic.yes") : t("economic.no"),
                                        },
                                        ...(!setup.economic_payment_matching_invoice ? [{
                                            label: t("economic.creditAccount"),
                                            value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payment_credit_account_number,'accountNumber','name'),
                                        }] : []),
                                    ]),
                                ]}
                            />

                            <SetupSectionCard
                                title={t("economic.sectionPayout")}
                                enabled={isSyncModuleEnabled(setup, "payout")}
                                toggling={togglingModule === "payout"}
                                onToggleEnabled={(enabled) => setModuleEnabled("payout", enabled)}
                                complete={isSetupSectionComplete("payout", setup)}
                                onEdit={() => setOpenModalSetupPayout(true)}
                                fields={[
                                    {
                                        label: t("economic.cashbook"),
                                        value: displaySetupValue(
                                            cashbooks.find((l: JournalInterface) => l.journalNumber == setup.economic_payout_cashbook_number)?.name,
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.bankAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payout_bank_account_number,'accountNumber','name'),
                                    },
                                    ...(!isLedger ? [{
                                        label: t("economic.payoutCreditAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payout_credit_account_number,'accountNumber','name'),
                                    }] : []),
                                    {
                                        label: t("economic.feeAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payout_fee_account_number,'accountNumber','name'),
                                    },
                                    {
                                        label: t("economic.differenceAccountCurrency"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_payout_difference_currency_account_number,'accountNumber','name'),
                                    },
                                ]}
                            >
                                {isLedger ? (
                                    <div className="alert alert-info py-2 mb-3" role="status">
                                        {t("economic.accountingModePayoutHelp")}
                                    </div>
                                ) : (
                                    <div className="alert alert-info py-2 mb-3" role="status">
                                        {t("economic.payoutFeeOptionalHelp")}
                                    </div>
                                )}
                            </SetupSectionCard>

                            <SetupSectionCard
                                title={t("economic.sectionSubscription")}
                                enabled={isSyncModuleEnabled(setup, "subscription")}
                                toggling={togglingModule === "subscription"}
                                onToggleEnabled={(enabled) => setModuleEnabled("subscription", enabled)}
                                complete={isSetupSectionComplete("subscription", setup)}
                                onEdit={() => setOpenModalSetupSubscription(true)}
                                fields={[
                                    {
                                        label: t("economic.cashbook"),
                                        value: displaySetupValue(
                                            cashbooks.find((l: JournalInterface) => l.journalNumber == setup.economic_subscription_cashbook_number)?.name,
                                            notSet
                                        ),
                                    },
                                    {
                                        label: t("economic.balanceAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_subscription_balance_account_number,'accountNumber','name'),
                                    },
                                    {
                                        label: t("economic.salesAccount"),
                                        value: getDisplayFromSelection(accounts,'accountNumber',setup.economic_subscription_sales_account_number,'accountNumber','name'),
                                    },
                                ]}
                            >
                                <p className="text-muted small mb-3">{t("economic.sectionSubscriptionHelp")}</p>
                            </SetupSectionCard>

                </div>
                )}
            </div>
        </React.Fragment>
    )
}

// @ts-ignore
export default React.memo(Economic);
